import React from "react";

function Widgets() {
  return (
    <div className="widgets pr-10 py-6">
      <iframe
        src="https://www.facebook.com/plugins/video.php?href=https://www.facebook.com/bakos.janos.9"
        frameBorder="0"
        width="340"
        height="auto"
        scrolling="no"
        allowtransparency="true"
        allow="encrypted-media"
      ></iframe>
    </div>
  );
}

export default Widgets;
